module.exports = __webpack_public_path__ + "static/black-aa-women-mobile.46a9688b.webp";